import { View, Text } from "react-native";
import ButtonIcon from "./buttons/ButtonIcon";
import TextPrimary from "./text/TextPrimary";
import * as Linking from "expo-linking";
import TextButtonPrimary from "./buttons/TextButtonPrimary";
import navigationNames from "../navigation/navigationNames";
import TextLink from "./buttons/TextLink";

interface FooterProps {
  onPress: (pageId: string) => void;
}

const Footer = (props: FooterProps) => {
  return (
    <View
      style={{
        paddingTop: 16,
        alignItems: "center",
      }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          //   padding: 16,
        }}
      >
        <ButtonIcon
          name="logo-github"
          onPress={() => Linking.openURL("http://github.com/mhazizk")}
          size={36}
          padding={8}
        />
        <ButtonIcon
          name="logo-twitter"
          onPress={() => Linking.openURL("http://twitter.com/juta_app")}
          size={36}
          padding={8}
        />
      </View>
      <View
        style={{
          flexDirection: "row",
        }}
      >
        <TextLink
          label="Terms"
          onPress={() => props.onPress(navigationNames.termsOfService.id)}
          viewStyle={{ padding: 8 }}
        />
        <TextLink
          label="Privacy"
          viewStyle={{ padding: 8 }}
          onPress={() => props.onPress(navigationNames.privacyPolicy.id)}
        />
        <TextLink
          label="About"
          viewStyle={{ padding: 8 }}
          onPress={() => props.onPress(navigationNames.about.id)}
        />
      </View>
      <View style={{}}>
        <TextPrimary
          label={
            new Date().getFullYear().toString() === "2023"
              ? "© " + new Date().getFullYear().toString()
              : "© 2023 - " + new Date().getFullYear().toString()
          }
        />
      </View>
    </View>
  );
};

export default Footer;
